<template>
  <b-form-row>
    <b-modal size="xl" button-size="sm" hide-footer :id="this.id" :title="prefix + title">
      <TipoAquisicaoIBPList :prefix="prefix + title" @onDblClickSelect="onDblClickSelect" />
    </b-modal>

    <lg-form-input-finder :disabled="disabled" :showClear="podeApagar" :value="computedValue" @input="updateValue"
      fieldDescription="descricao" :label="label" invalidFeedback="Tipo de Medida deve ser informada!" description=""
      @handleClean="handleClean" :error="error">
      <template #prepend>
        <b-button :disabled="disabled" @click="show" class="btn-input-finder"  v-if="podeMudar">
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import TipoAquisicaoIBPList from "@/modules/cadastros/tipo-aquisicao-ibp/TipoAquisicaoIBPList";
export default {
  components: { LgFormInputFinder, TipoAquisicaoIBPList },
  props: {
    id: String,
    prefix: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "Tipo Aquisição"
    },
    podeMudar: {
      type: Boolean,
      default: true
    },
    podeApagar: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: "Tipo Aquisição:"
    },
    value: Object,
    error: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      internalValue: this.value || {},
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue;
      },
      set(newValue) {
        this.internalValue = newValue;
      },
    },

  },
  methods: {
    show() {
      this.$bvModal.show(this.id);
    },
    updateValue(newValue) {
      this.computedValue = newValue;
      this.$emit('input', newValue);
    },
    handleClean() {
      this.computedValue = {};
      this.$emit('input', {});
    },
    onDblClickSelect(item) {
      this.computedValue = item;
      this.$emit('input', item);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
